import {getProfiles} from 'backend-helpers/profiles';

export default class AutoSuggestDataProvider {
    search(value, maxItems) {
        return getProfiles({
            query: value,
            only_nick: 1,
            limit: maxItems
        })
    }
}


// WEBPACK FOOTER //
// ./src/containers/member/AutosuggestDataProvider.js